(function () {
  if (window.__mdlPdpStockDeliveryStatusBound) return;
  window.__mdlPdpStockDeliveryStatusBound = true;

  var updateScheduled = false;
  var retryTimers = [];

  function getDataNode() {
    return document.querySelector('[data-mdl-product-stock-data]');
  }

  function getProductManager() {
    return document.querySelector('product-manager');
  }

  function isVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    var styles = window.getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
  }

  function getMainAtcTarget() {
    var manager = getProductManager();
    if (!manager) return null;

    var nativeBundleAtc = manager.querySelector('button.mdl-native-bundle-atc');
    if (isVisible(nativeBundleAtc)) return nativeBundleAtc;

    var atcRows = Array.prototype.slice.call(manager.querySelectorAll('.pdp-atc-row'));
    var visibleAtcRow = atcRows.find(isVisible);
    if (visibleAtcRow) return visibleAtcRow;
    if (atcRows[0]) return atcRows[0];

    var atcButtons = Array.prototype.slice.call(manager.querySelectorAll('button[data-main-add-to-cart]'));
    return atcButtons.find(function (button) {
      return !button.closest('sticky-add-to-cart');
    }) || atcButtons[0] || null;
  }

  function getSelectedVariantId(manager) {
    var packSelect = manager && manager.querySelector('#mdl-pack-select');
    var packSelectValue = packSelect && String(packSelect.value || '').trim();
    if (packSelectValue) return packSelectValue;

    var form = manager && manager.querySelector('form[data-form="product"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var inputValue = idInput && String(idInput.value || '').trim();

    if (inputValue) return inputValue;

    try {
      var urlVariantId = new URLSearchParams(window.location.search).get('variant');
      return urlVariantId ? String(urlVariantId).trim() : '';
    } catch (error) {
      return '';
    }
  }

  function parseInventory(dataNode) {
    try {
      var parsed = JSON.parse(dataNode.textContent || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function createProductStatus(dataNode) {
    var status = document.createElement('div');
    status.className = 'mdl-stock-delivery-status mdl-stock-delivery-status--product';
    status.setAttribute('data-mdl-stock-delivery-status', '');
    status.setAttribute('data-mdl-stock-delivery-context', 'product');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');

    var availability = document.createElement('span');
    availability.className = 'mdl-stock-delivery-status__availability';
    var dot = document.createElement('span');
    dot.className = 'mdl-stock-delivery-status__dot';
    dot.setAttribute('aria-hidden', 'true');
    var label = document.createElement('span');
    label.textContent = dataNode.dataset.mdlStockLabel || '';
    availability.append(dot, label);

    var delivery = document.createElement('span');
    delivery.className = 'mdl-stock-delivery-status__delivery';
    var separator = document.createElement('span');
    separator.className = 'mdl-stock-delivery-status__separator';
    separator.setAttribute('aria-hidden', 'true');
    separator.textContent = '•';
    var deliveryLabel = document.createElement('span');
    deliveryLabel.textContent = dataNode.dataset.mdlDeliveryLabel || '';
    delivery.append(separator, deliveryLabel);

    status.append(availability, delivery);
    return status;
  }

  function updateProductStatus() {
    var dataNode = getDataNode();
    var manager = getProductManager();
    var atcTarget = getMainAtcTarget();
    if (!dataNode || !manager || !atcTarget || !atcTarget.parentElement) return;

    var status = document.querySelector('[data-mdl-stock-delivery-context="product"]');
    if (!status) status = createProductStatus(dataNode);
    if (atcTarget.classList.contains('pdp-atc-row')) {
      if (status.parentElement !== atcTarget || status !== atcTarget.lastElementChild) {
        atcTarget.appendChild(status);
      }
    } else if (status.parentElement !== atcTarget.parentElement || status.previousElementSibling !== atcTarget) {
      atcTarget.insertAdjacentElement('afterend', status);
    }

    var inventory = parseInventory(dataNode);
    var variantId = getSelectedVariantId(manager);
    var inventoryQuantity = Number(inventory[variantId] || 0);
    var inStock = inventoryQuantity > 0;

    status.hidden = !inStock;
    status.dataset.mdlVariantId = variantId;
    status.dataset.mdlInventoryQuantity = String(inventoryQuantity);
    Array.prototype.forEach.call(manager.querySelectorAll('.pdp-atc-row'), function (row) {
      row.removeAttribute('data-mdl-has-stock-status');
    });
    if (atcTarget.classList.contains('pdp-atc-row') && inStock) {
      atcTarget.setAttribute('data-mdl-has-stock-status', '');
    }
  }

  function scheduleUpdate() {
    if (updateScheduled) return;
    updateScheduled = true;
    window.requestAnimationFrame(function () {
      updateScheduled = false;
      updateProductStatus();
    });
  }

  function scheduleVariantUpdate() {
    scheduleUpdate();
    retryTimers.forEach(function (timer) { window.clearTimeout(timer); });
    retryTimers = [50, 180, 450].map(function (delay) {
      return window.setTimeout(scheduleUpdate, delay);
    });
  }

  function isProductVariantInteraction(target) {
    return Boolean(target && target.closest && target.closest('product-manager'));
  }

  document.addEventListener('change', function (event) {
    if (isProductVariantInteraction(event.target)) scheduleVariantUpdate();
  }, true);

  document.addEventListener('input', function (event) {
    if (isProductVariantInteraction(event.target)) scheduleVariantUpdate();
  }, true);

  var observer = new MutationObserver(function () {
    scheduleUpdate();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  function boot() {
    scheduleVariantUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
